import { FC, Fragment, useState } from "react";
import { FileDetails } from "./components/FileDetails";
import {
  Alert,
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Grid,
  Toolbar,
  Typography,
} from "@mui/material";
import { FileUploader } from "./components/FileUploader";
import GavelIcon from "@mui/icons-material/Gavel";
import axiosInstance from "./api/axios";

export const App: FC = () => {
  const [fileDetails, setFileDetails] = useState<any>(null);
  const [fileSelected, setFileSelected] = useState<File>();
  const [isUploadingFile, setIsUploadingFile] = useState<Boolean>(false);
  const [hasError, setHasError] = useState<Boolean>(false);

  const handleFile = (file: File) => {
    setFileSelected(file);
  };

  const handleFileUpload = async (file: File) => {
    setIsUploadingFile(true);
    setHasError(false);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post("/verify_signature", formData);
      setFileDetails(response.data);
    } catch (error) {
      setHasError(true);
      console.error(error);
    } finally {
      setIsUploadingFile(false);
    }
  };

  const resetFileSelected = () => {
    setHasError(false);
    setFileDetails(null);
    setFileSelected(undefined);
  };

  return (
    <Fragment>
      <AppBar
        position="relative"
        color="default"
        elevation={0}
        sx={{ borderBottom: "1px solid" }}
      >
        <Toolbar>
          <img src="/images/smartpass-logo.png" alt="logo" />
          <Typography ml={2} variant="h5" noWrap>
            Smartpass X-Sign
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" component="main" sx={{ pt: 8, pb: 6 }}>
        <Grid container spacing={1} alignItems="flex-end">
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              {fileDetails ? (
                <FileDetails
                  digitalSignature={fileDetails}
                  fileName={fileSelected ? fileSelected.name : ""}
                  resetFileSelected={resetFileSelected}
                />
              ) : (
                <Fragment>
                  <CardHeader
                    title="Selecione um documento PDF para validação das assinaturas digitais."
                    titleTypographyProps={{ align: "center" }}
                    subheaderTypographyProps={{
                      align: "center",
                    }}
                  />
                  <CardContent>
                    <Box className="row" sx={{ p: 2 }}>
                      <Box alignItems="center">
                        <Typography align="center" variant="h6">
                          <FileUploader onFileUpload={handleFile} />
                          {fileSelected && (
                            <Typography mt={2}>
                              <strong>Arquivo selecionado:</strong>{" "}
                              {fileSelected.name}
                            </Typography>
                          )}
                        </Typography>
                      </Box>
                    </Box>
                    {fileSelected && (
                      <Fragment>
                        <hr />
                        <Typography align="center" mt={3}>
                          <Button
                            variant="outlined"
                            color="info"
                            startIcon={
                              isUploadingFile ? (
                                <CircularProgress
                                  size="1rem"
                                  sx={{ color: "inherit" }}
                                />
                              ) : (
                                <GavelIcon />
                              )
                            }
                            disabled={
                              fileSelected === undefined || !isUploadingFile
                                ? false
                                : true
                            }
                            onClick={() =>
                              fileSelected && handleFileUpload(fileSelected)
                            }
                          >
                            Validar
                          </Button>
                        </Typography>
                      </Fragment>
                    )}
                  </CardContent>
                  {hasError && (
                    <CardContent>
                      <hr />
                      <Typography align="center" mt={3}>
                        <Alert variant="outlined" severity="error">
                          Não foi possível validar o documento selecionado,
                          tente novamente.
                        </Alert>
                      </Typography>
                    </CardContent>
                  )}
                </Fragment>
              )}
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};
